<template>
  <div class="search-input -multi">
    <div class="inner">
      <slot></slot>
    </div>
    <button
      type="submit"
      class="search test"
      @click="$emit('submit')"
      :disabled='submitDisabled ? "disabled" : null'
      >
      Search
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      submitDisabled: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
